module.exports = __webpack_public_path__ + "static/media/supplier-address.4307e12f.svg";